// generated

import flattenHierarchy from "backend/flattenHierarchy";
import useElement from "backend/hooks/elements/useElement";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import { ElementOverviewDonutCard } from "design/components/cards/ElementOverviewDonutCard";
import OverallPerformanceCard from "design/components/cards/OverallPerformanceCard";
import { IChartSelectEvent } from "design/components/charts/types";
import { PerformanceSummaryBars } from "design/components/lists/SummaryCard";
import InitiativeDrillDown from "design/components/popups/InitiativeDrillDown";
import KPIDrillDown from "design/components/popups/KPIDrillDown";
import Center from "design/layouts/Center";
import PageContainer from "design/layouts/PageContainer";
import SplitView from "design/layouts/SplitView";
import Page from "design/pages/Page";
import { t } from "i18next";
import * as conf from "qpr-base/configuration";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import Loader from "qpr-base/ui/components/Loader";
import React from "react";

const Overview = (props: {
  elementId?: string;
  setId?: string;
  backgroundColor?: string;
  isComponent?: boolean;
  hideRanges?: boolean;
}) => {
  const { data: root } = useScorecardTopElement("L0");

  const ctx = useAppContext();
  const link = useLink();

  const [showKPIModal, setShowKPIModal] =
    React.useState<IChartSelectEvent | null>(null);
  const [showInitiatives, setShowInitiatives] =
    React.useState<IChartSelectEvent | null>(null);

  const {
    data,
    isLoading: isDataLoading,
    isError,
    isPreviousData,
    isRefetching,
  } = useHierarchy(ctx.elementId || root?.id);

  const overviewKPIlist = React.useMemo(() => {
    return flattenHierarchy(data).filter(
      (el) => el.typename === "KPI" && el.STATUS === "1"
    );
  }, [data]);

  const overviewInitiativelist = React.useMemo(() => {
    return flattenHierarchy(data).filter(
      (el) => el.typename === "Initiative" && el.STATUS === "1"
    );
  }, [data]);

  const { data: el, isLoading: isElementLoading } = useElement(
    ctx.elementId || root?.id
  );

  if (
    !data ||
    isElementLoading ||
    isDataLoading ||
    isRefetching ||
    isPreviousData
  )
    return (
      <div>
        <StrategyToolbar />
        <Loader />
      </div>
    );

  return (
    <Page
      isLoading={
        !data ||
        isElementLoading ||
        isDataLoading ||
        isRefetching ||
        isPreviousData
      }
      Toolbar={StrategyToolbar}
    >
      <PageContainer>
        <KPIDrillDown
          title={
            showKPIModal?.name === "No Value"
              ? t("overview.KPIs with no data")
              : `${showKPIModal?.name} ${t("overview.performing KPIs")}`
          }
          showModal={showKPIModal}
          onClose={() => {
            setShowKPIModal(null);
          }}
          items={overviewKPIlist}
        />
        <InitiativeDrillDown
          title={
            showInitiatives?.name === "No Value"
              ? t("overview.Initiatives with no data")
              : `${showInitiatives?.name} ${t(
                  "overview.performing Initiatives"
                )}`
          }
          showModal={showInitiatives}
          onClose={() => {
            setShowInitiatives(null);
          }}
        />

        <SplitView partCnt={1} gap="30px">
          <Center>
            {conf.getOverviewDashboardSettings().hideOverallPerformance ===
            true ? null : (
              <div style={{ height: "100%" }}>
                <OverallPerformanceCard
                  element={el!}
                  periodName={el?.periodname || ""}
                  key="PERF_W_YTD"
                  titleKey="PERF_W_YTD_prettyvalue"
                  title={t("overview.Overall Performance")}
                />
              </div>
            )}
            <ElementOverviewDonutCard
              title={t("overview.KPI Overview")}
              data={overviewKPIlist}
              typenames={["KPI"]}
              periodName={el?.periodname || ""}
              onSelect={(event) => {
                console.log("setShowKPIModal", event);
                setShowKPIModal(event);
              }}
            />
            <ElementOverviewDonutCard
              title={t("overview.Initiative Overview")}
              data={overviewInitiativelist}
              typenames={["Initiative"]}
              periodName={el?.periodname || ""}
              onSelect={(event) => {
                console.log("setShowInitiatives", event);
                setShowInitiatives(event);
              }}
            />
          </Center>
        </SplitView>

        <PerformanceSummaryBars
          elements={data}
          periodName={ctx.period || ""}
          typenames={["KPI", "Initiative"]}
          title={t("overview.Perspective")}
          onSelect={(event) => {
            if (event.category === "KPI") {
              setShowKPIModal(event);
            }
            if (event.category === "Initiative") {
              setShowInitiatives(event);
            }
          }}
        />
      </PageContainer>
    </Page>
  );
};
export default Overview;
